import service from './apiAnalise.services';

const getAnalisesByIdProcessoAnaliseEquipe = async (idProcesso) => {
    if (!idProcesso) throw new Error('ID do processo é obrigatório');
    const response = await service.get(`/processo/${idProcesso}/analises`);
    return response.data;
};

const downloadParecerAtivo = async (idProcesso) => {
    if (!idProcesso) throw new Error('ID do processo é obrigatório');
    return downloadArquivo(`/analiseTecnica/${idProcesso}/parecer`);
};

const downloadRelatorioAnaliseTecnica = async (numRelatorio) => {
    if (!numRelatorio) throw new Error('Número do relatório é obrigatório');
    return downloadArquivo(`/analiseTecnica/relatorioAnaliseTecnica?numeroRelatorio=${numRelatorio}`);
};

const downloadNotificacaoDocumentoById = async (idDocumento) => {
    if (!idDocumento) throw new Error('ID do documento é obrigatório');
    return downloadArquivo(`/documento/${idDocumento}/baixar`);
};

const downloadArquivo = (url) =>
    service.get(url, {
        responseType: 'blob',
        timeout: 30000,
        validateStatus: status => status >= 200 && status < 300,
        headers: {
            'Accept': 'application/pdf'
        },
        hideErrorToast: true
    });

export { getAnalisesByIdProcessoAnaliseEquipe, downloadParecerAtivo, downloadRelatorioAnaliseTecnica, downloadNotificacaoDocumentoById };
